import MesureFormAccreditationController from './mesure.form.accreditation.controller';

export default {
    bindings: {
        mesure: '='
    },
    template: require('./mesure.form.accreditation.html'),
    controller: MesureFormAccreditationController
};
